// extracted by mini-css-extract-plugin
export default {"dockContainer":"AppsList_dockContainer__XKFYq","active":"AppsList_active__R9WU3"};